// Product tour for the final signup step (SMP-1174). The matching tour is resolved
// and rendered server-side (product-flow.twig); this module drives the "go to
// account" button and persists progress so an abandoned tour reopens on return.

import { getTour, saveTour, clearTour } from './_tourStorage'

let envReady = false
let tourActive = false

function goToEnvironment() {
    const tour = getTour()
    const tourPending = tourActive && !!tour && !tour.finished && !tour.replayed

    if (tourPending) {
        saveTour({ skipped: true })
    } else {
        clearTour()
    }

    if (typeof window.goToDomain === 'function') {
        window.goToDomain({ tourPending })
    }
}

function updateButton() {
    const button = document.querySelector('.product-tour-enter')
    if (!button) {
        return
    }

    // Loader until the account exists. The tour is offered, not required: gating the
    // button on `demo_finished` locked people out whenever that event never arrived.
    button.classList.toggle('is-loading', !envReady)
    button.disabled = !envReady
}

// Called by _enviromentCreation.js once the environment is ready.
function onEnvironmentReady() {
    envReady = true

    if (tourActive) {
        updateButton()
    } else {
        goToEnvironment()
    }
}

// Storylane posts cross-frame messages as the demo is watched, but only when its
// embed script is loaded — a bare iframe delivers nothing, so treat this as a
// best-effort signal and never let the flow depend on it.
// See https://docs.storylane.io/integrations/integrations-and-data-flow/cross-frame-events
function listenForTourEvents() {
    window.addEventListener('message', (event) => {
        const data = event.data

        if (!data || data.message !== 'storylane-demo-event' || !data.payload) {
            return
        }

        if (data.payload.event === 'demo_finished') {
            saveTour({ finished: true })
        }
    })
}

export default function initProductTour() {
    // Own the readiness signal before environment creation starts polling.
    window.simplicateEnvironmentReady = onEnvironmentReady

    const container = document.querySelector('.product-tour')
    tourActive = !!container && !container.classList.contains('hidden')

    if (!tourActive) {
        return
    }

    // Storylane embeds can't resume mid-step, so a reopened tour restarts from the
    // beginning; the stored flag only records how far the user got with it.
    const stored = getTour()

    if (!stored) {
        saveTour({ finished: false })
    } else if (stored.skipped) {
        // A skipped tour gets one replay, and this is it — mark it so the next visit
        // to the signup form isn't bounced here again. Reloads stay idempotent.
        saveTour({ replayed: true })
    }

    const button = container.querySelector('.product-tour-enter')
    if (button) {
        button.addEventListener('click', goToEnvironment)
    }

    listenForTourEvents()
    updateButton()
}
